var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Tab, Tabs } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { METRIC_LIST } from './constants';
import { FREQUENCY_ENUM, METRICS_ENUM } from './enum';
import { useSelectDisabledMetrics } from './selectors';
var StyledTabs = styled(Tabs)(function (_a) {
  var theme = _a.theme;
  return {
    minHeight: '2rem',
    '& .MuiTabs-indicator': {
      backgroundColor: 'transparent',
      display: 'flex',
      justifyContent: 'center',
      height: '0.25rem',
      '& > span': {
        height: '0.25rem',
        width: '87%',
        backgroundColor: theme.palette.primary.main
      }
    },
    '& .MuiTab-root': {
      minHeight: '2rem',
      textTransform: 'none',
      fontSize: theme.typography.pxToRem(14),
      fontWeight: 400,
      fontStyle: 'normal',
      borderRight: '0.0625rem solid',
      borderColor: theme.palette.divider,
      padding: "0 ".concat(theme.spacing(3)),
      minWidth: 'auto',
      color: theme.palette.primary.main,
      '&:last-of-type': {
        borderRight: 'none'
      },
      '&:hover': {
        textDecoration: 'underline',
        transition: 'all 0.5s ease'
      }
    },
    '& .Mui-selected': {
      textShadow: '0.044rem 0 0' + theme.palette.common.black,
      '&:hover': {
        textDecoration: 'unset',
        cursor: 'default'
      }
    }
  };
});
export var DataPanelMetricTabs = function (_a) {
  var sectionType = _a.sectionType,
    frequency = _a.frequency;
  var t = useTranslation('report', {
    keyPrefix: 'actual.metrics'
  }).t;
  var control = useFormContext().control;
  var metricDisabled = useSelectDisabledMetrics();
  return _jsx(Controller, {
    name: "metricTab",
    control: control,
    render: function (_a) {
      var _b = _a.field,
        value = _b.value,
        onChange = _b.onChange;
      return _jsx(StyledTabs, __assign({
        variant: "scrollable",
        scrollButtons: false,
        value: value,
        onChange: function (_event, newValue) {
          onChange(newValue);
        },
        indicatorColor: "primary",
        textColor: "primary",
        TabIndicatorProps: {
          children: _jsx("span", {})
        }
      }, {
        children: METRIC_LIST[sectionType].map(function (metric) {
          return _jsx(Tab, {
            label: t(metric),
            value: metric,
            disabled: metricDisabled[metric] || frequency === FREQUENCY_ENUM.DAILY && metric === METRICS_ENUM.ATTRITION
          }, metric);
        })
      }));
    }
  });
};